import type { TFunction } from 'i18next'

export const getLocationUnavailableText = (t: TFunction): string => t('notification.v2.location.unavailable')
export const getAddressUnavailableText = (t: TFunction): string => t('notification.v2.location.addressUnavailable')

export interface IAlertLocation {
    latitude?: number | null
    longitude?: number | null
    address?: string | null
}

export const hasAlertCoordinates = (
    location?: IAlertLocation | null
): location is IAlertLocation & { latitude: number; longitude: number } =>
    typeof location?.latitude === 'number' &&
    typeof location?.longitude === 'number' &&
    Number.isFinite(location.latitude) &&
    Number.isFinite(location.longitude)

export const formatAlertLocation = (
    location: IAlertLocation | null | undefined,
    t: TFunction,
    maskAddress: (address?: string) => string | undefined = address => address
): string => {
    if (!hasAlertCoordinates(location)) return getLocationUnavailableText(t)
    if (!location.address) return getAddressUnavailableText(t)
    return maskAddress(location.address) || getAddressUnavailableText(t)
}
